import { connectToParent } from '@livechat/postmessage/es5';

var methodNames = ['sendMessage', 'setAttributes', 'close'];
function createMomentsSDK(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      title = _ref.title,
      icon = _ref.icon;

  return connectToParent({
    title: title,
    icon: icon
  }).promise.then(function (_ref2) {
    var call = _ref2.call;
    return methodNames.reduce(function (momentsSDK, name) {
      momentsSDK[name] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return call.apply(void 0, [name].concat(args));
      };

      return momentsSDK;
    }, {});
  });
}

export default createMomentsSDK;
